import {
    Grid
} from '@mui/material';

import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import ReactTooltip from 'react-tooltip';
import { useState } from 'react';


const classes = {
    yearItem: {
        width: '100%',
        border: 'solid 1px #D9CBCB',
        backgroundColor: '#FFFDFD',
        color: '#155BCB',
        borderRadius: 5,
        fontWeight: 600,
        textAlign: 'center',
        cursor: 'pointer'
    },
    yearItemSelected: {
        width: '100%',
        textAlign: 'center',
        border: 'solid 1px #D9CBCB',
        backgroundColor: '#A7DB64',
        color: '#155BCB',
        borderRadius: 5,
        fontWeight: 600,
        cursor: 'pointer'
    },
}

const MESSAGE_FILTER = {
    true: 'Limpar Filtro',
    false: 'Clique em um dos itens para usar o filtro'
};


export default function SelectYear({ years, setYears }) {

    const [filterActive, setFilterActive] = useState(true);

    //Para desativar o filtro basta limpar todos os campos
    const desactiveFilter = () => {
        setYears(prev => prev.map((item) => ({ ...item, isActive: false })));
        setFilterActive(false);
    }

    const handleClickYear = (year, idx) => {
        setFilterActive(true);
        let copy = structuredClone(years);
        copy[idx].isActive = !copy[idx].isActive;
        setYears(copy);
    }

    return (
        <>
            <div style={{width: '90%', margin: '8px auto 20px auto'}} id="select-range-dashboard">
                <Grid container spacing={2} item justifyContent="space-between" style={{ height: 40 }}>
                    <Grid item style={{ color: '#155BCB' }}>
                        Ano
                    </Grid>

                    <Grid item>
                        <ReactTooltip id="proportion-info" className='popup' />
                        <div data-for="proportion-info" data-place="bottom" data-tip={MESSAGE_FILTER[filterActive]} style={{ color: '#155BCB', cursor: 'pointer' }}>
                            {
                                filterActive ?
                                    <FilterAltOffOutlinedIcon onClick={desactiveFilter} /> :
                                    <FilterAltOutlinedIcon />
                            }
                        </div>
                    </Grid>
                </Grid>

                <Grid container spacing={1} item style={{ height: 90, overflowY: 'scroll', overflowX: 'hidden', marginTop: '10px', alignContent: 'flex-start' }}>
                    {
                        years.map((year, idx) => (
                            <Grid item xs={6} sm={6} md={6} lg={4} key={idx} style={{ height: 30 }}>
                                <div
                                    onClick={() => handleClickYear(year, idx)}
                                    style={year.isActive ? classes.yearItemSelected : classes.yearItem}
                                >
                                    {year.name}
                                </div>
                            </Grid>
                        ))
                    }
                </Grid>
            </div>
        </>
    )
}